module.exports = __webpack_public_path__ + "static/media/hopes.64595d27.png";